const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getOrderDetail({ rootState, commit }, params = {}) {
      const data = await rootState.http("/order/getOrderDetail", Object.assign(params, { clientType: "10" }));
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/service.js